<template>
  <div id="CollectionBnkAccount" class="sun">
    <p class="title">
      카드 매출 입금계좌(BNK경남):
    </p>
    <ValidationObserver v-slot="{ invalid }" ref="collectionvalidform" slim>
      <form @submit.prevent="putCollectionAccount()">
        <FormInput
          type="tel"
          @input="inputAccountNo('collection')"
          v-model="collection.account_number"
          rules="required|numeric"
          placeholder="BNK경남은행 계좌번호"
          :disabled="!isUpdatable || isLoading"
        />
        <button
          type="submit"
          v-if="isUpdatable"
          :disabled="invalid || isLoading"
          class="section-btn"
        >
          {{user && user.collection_account && user.collection_account.account_number && user.collection_account.account_number.length > 1 ? 'ARS 인증 & 수정' : 'ARS 인증 & 저장'}}
          <v-progress-circular
            style="padding-left: 15px;"
            size="16"
            v-if="isLoading"
            indeterminate
            color="primary"
          />
        </button>
      </form>
    </ValidationObserver>
    <div class="guide">
      <div class="guide-item" v-if="stepFirst">
        <div class="description">
          카드매출 입금 용도로 사용되는 계좌입니다.
        </div>
      </div>
      <div class="guide-item" v-else-if="stepArs">
        <div class="description">
          1~5분내로 ARS 인증 전화가 올 예정입니다. 발신번호는 6925-1788 입니다.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Services
import UserService from '@/service/user/UserService'

// Components
import FormInput from '@/components/form/FormInput'

// Variable Section
let self

export default {
  name: 'CollectionBnkAccount',
  components: {
    FormInput
  },
  props: ['collection', 'isUpdatable', 'user'],
  data() {
    return {
      isLoading: false
    }
  },
  created() {
    self = this
    self.collection.bank = 39
    self.device = localStorage.getItem('device')
  },
  computed: {
    stepArs() {
      return this.isLoading
    },
    stepFirst() {
      return !this.account_number && !this.isLoading
    },
  },
  methods: {
    inputAccountNo(type) {
      let number = this[type].account_number
      if (number != null && number.length > 0) {
        this[type].account_number = number.replace(/[^\d]/g, '')
      }
    },
    async putCollectionAccount() {
      if (self.isLoading === true) {
        alert('저장중입니다.')
        return
      }
      self.isLoading = true

      let obj = Object.assign({}, self.collection)
      obj.bank = 39 // 웰컴

      try {
        await UserService.putUserCollectionAccount(obj)
        alert('등록이 완료되었습니다.')
      } catch (e) {
        console.log(e)
        if (e.data) {
          let message = e.data
          message = message.replace(/'/g, '"')
          message = message.replace(/None/g, 'null')
          message = JSON.parse(message)
          if (message.result_message) {
            alert(message.result_message)
            return
          }
        }
        alert('계좌 저장에 실패했습니다')
      } finally {
        this.isLoading = false
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  $default-blue-color: #1baaf1;
  $btn-disable-background-color: #e3ecf6;
  $gray-text-color: #727d8c;
  #CollectionBnkAccount {
    width: 100%;
    font-size: 16px;
    padding-top: 12px;
    padding-bottom: 12px;

    .title {
      font-weight: 900;
      margin-bottom: 16px;
    }

    .section-btn {
      font-size: 18px;
      color: #ffffff;
      background-color: #333333;
      margin-bottom: 8px;
    }

    .reason {
      color: $gray-text-color;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.2px;
      strong {
        font-weight: 900;
      }
    }

    .title {
      font-weight: 900;
      margin-bottom: 9px;
    }
    .guide {
      margin-top: 8px;

      .guide-item {
        .description {
          font-weight: normal;
          font-size: 14px;
          color: $gray-text-color;
          line-height: 1.43;
        }

        .download {
          width: 100%;
          font-size: 12px;
          color: $gray-text-color;
          line-height: 27px;
          margin-top: 8px;
          float: right;
          .buttons {
            float: right;
            a {
              float: left;
              display: inline-block;
              padding: 6px 12px;
              font-size: 12px;
              line-height: 15px;
              border-radius: 15px;
              color: #727d8c;
              background-color: white;
              text-decoration: none;
              border: solid 1px #d7e1ea;
              margin-left: 4px;
            }
          }
        }
      }
    }

    input {
      margin-bottom: 10px;
    }
    button {
      background-color: $default-blue-color;
      color: #ffffff;
      &:disabled {
        color: $gray-text-color;
        background-color: $btn-disable-background-color;
      }
    }

    .section-btn {
      width: 100%;
      border-radius: 4px;
      font-weight: 700;
      text-align: center;
      padding-top: 13px;
      padding-bottom: 13px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: row;
    }
  }
</style>
